
import Vue from 'vue';
import LoginAndSignupModal from '@customer/components/login-and-sign-up/LoginAndSignupModal.vue';

interface Props {
  hideSignup: boolean;
}

export default Vue.extend<unknown, unknown, unknown, Props>({
  components: {
    LoginAndSignupModal,
  },
  props: {
    hideSignup: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
